import styles from '@components/components/CmsComponents/components/CmsBenefits/CmsBenefits.module.scss';
import React from 'react';
import { Heading, IconText, getHeadingTag } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const CmsBenefits = ({
  headingLevel = 2,
  isCard,
  isList,
  items,
  title,
  ScrollIndexVertical,
  containerDimension,
}) => (
  <section
    className={classNames(styles.container, {
      [styles.hasHeading]: title,
    })}
  >
    {title && (
      <Heading as={getHeadingTag(headingLevel)} size="h2">
        {title}
      </Heading>
    )}
    <div
      className={classNames(styles.list, {
        [styles.noGrid]: isList,
        [styles.isInContainer]:
          containerDimension && containerDimension !== 'full',
      })}
    >
      {items?.map(({ heading, icon, iconTheme, id, text }) => (
        <IconText
          className={styles.benefitItem}
          glyph={icon}
          heading={heading}
          headingLevel={title ? headingLevel + 1 : headingLevel}
          iconTheme={iconTheme}
          isCard={isCard}
          key={id}
          scrollIndex={ScrollIndexVertical}
          text={text}
        />
      ))}
    </div>
  </section>
);
export default CmsBenefits;
